<template>
  <main>
  <div id="app">
    <!-- <Submission /> -->
  </div>
    <MainAwards />
  </main>
</template>

<script>
import { getBaseURL, getBaseMetaCurrentYear } from '@/environments'
// const Submission = () => import('@/components/Submission/Main')
const MainAwards = () => import('@/components/Awards/Main')

export default {
  components: {
    // Submission,
    MainAwards
  },

  metaInfo: {
    meta: [
      { name: 'publisher', content: 'admanawards.com/' },
      { name: 'og:url', content: getBaseURL() },
      { name: 'og:title', content: `Adman Awards & Symposium ${getBaseMetaCurrentYear}` },
      { name: 'og:description', content: 'Be the First Winner of the Most Honorable Award' },
      { name: 'og:image', content: `${getBaseURL()}/img/og_adman.jpg` },
      { name: 'og:site_name', content: 'AdmanAwards' },
      { name: 'og:type', content: 'website' }
      // you can also add open graph tags here
    ]
  }
}
</script>
